import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53167)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 30.4595H49.9999V40.5169C49.9999 40.993 49.6139 41.379 49.1378 41.379H0.862108C0.386034 41.379 0 40.993 0 40.5169V30.4595Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271V19.5401H0V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 19.54H0V30.459H49.9999V19.54Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3796 19.8271H18.9658V22.5859H21.3796V19.8271Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2067 19.8271H23.793V22.5859H26.2067V19.8271Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7927 22.5859H21.3789V25.3447H23.7927V22.5859Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0339 19.8271H28.6201V22.5859H31.0339V19.8271Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6208 22.5859H26.207V25.3447H28.6208V22.5859Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7927 19.8271H21.3789V22.5859H23.7927V19.8271Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6208 19.8271H26.207V22.5859H28.6208V19.8271Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3796 22.5859H18.9658V25.3447H21.3796V22.5859Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2067 22.5859H23.793V25.3447H26.2067V22.5859Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0339 22.5859H28.6201V25.3447H31.0339V22.5859Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2062 25.3447H23.7925V28.1035H26.2062V25.3447Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7922 28.1035H21.3784V30.8623H23.7922V28.1035Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6203 28.1035H26.2065V30.8623H28.6203V28.1035Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7927 25.3447H21.3789V28.1035H23.7927V25.3447Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6203 25.3447H26.2065V28.1035H28.6203V25.3447Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2062 28.1035H23.7925V30.8623H26.2062V28.1035Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0346 19.8275V27.5861C31.0346 30.9188 28.3329 33.6206 25.0002 33.6206C21.6675 33.6206 18.9657 30.9188 18.9657 27.5861V19.8275H31.0346ZM31.4657 19.3965H31.0346H18.9657H18.5347V19.8275V27.5861C18.5347 31.1512 21.4351 34.0516 25.0002 34.0516C28.5653 34.0516 31.4657 31.1512 31.4657 27.5861V19.8275V19.3965Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3806 28.1033V25.3447H18.9668V27.5861C18.9668 27.7608 18.9783 27.9324 18.9929 28.1034H21.3806V28.1033Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0083 28.1035H28.6206V30.8621H30.0634C30.587 30.0546 30.9223 29.1154 31.0083 28.1035Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9366 30.862H21.3794V28.1035H18.9917C19.0777 29.1153 19.4131 30.0545 19.9366 30.862Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6211 28.1034H31.0088C31.0233 27.9326 31.0349 27.7608 31.0349 27.5861V25.3447H28.6211V28.1034Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3798 32.4054V30.8618H19.937C20.3236 31.4582 20.8133 31.9791 21.3798 32.4054Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0639 30.8618H28.6211V32.4054C29.1877 31.9791 29.6773 31.4582 30.0639 30.8618Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3794 32.4054C22.0819 32.9342 22.8996 33.318 23.7932 33.4993V30.8618H21.3794V32.4054Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2065 33.4993C27.1001 33.318 27.9178 32.9341 28.6203 32.4054V30.8618H26.2065V33.4993Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2067 30.8618H23.793V33.4993C24.1829 33.5785 24.5865 33.6205 24.9999 33.6205C25.4133 33.6205 25.8168 33.5785 26.2068 33.4993V30.8618H26.2067Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.632 15.2631C20.1068 15.1818 19.5695 15.1232 19.0218 15.0894C18.5981 15.4381 18.1943 15.8017 17.811 16.1782C18.196 17.1074 18.5809 18.0366 18.9656 18.9658C19.7384 18.6458 20.5302 18.3896 21.3335 18.1976C21.0997 17.2194 20.8659 16.2412 20.632 15.2631Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4652 14.8052C25.9933 14.5664 25.5046 14.3456 25.0002 14.1445C24.4958 14.3457 24.007 14.5665 23.5352 14.8052C23.6136 15.8077 23.6921 16.8104 23.7705 17.8133C24.5891 17.7491 25.4115 17.7491 26.2301 17.8133C26.3083 16.8105 26.3868 15.8079 26.4652 14.8052Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.189 16.1782C31.8057 15.8018 31.4018 15.4382 30.9782 15.0894C30.4305 15.1231 29.8932 15.1818 29.368 15.2631C29.1342 16.2413 28.9003 17.2194 28.6665 18.1976C29.4698 18.3896 30.2616 18.6457 31.0344 18.9657C31.4192 18.0365 31.8041 17.1073 32.189 16.1782Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5348 14.8053C23.0314 14.6429 22.5137 14.5008 21.9826 14.3809C21.5141 14.6583 21.0636 14.9529 20.6318 15.263C20.8656 16.2412 21.0995 17.2193 21.3335 18.1975C22.1368 18.0054 22.9516 17.8774 23.7702 17.8134C23.6917 16.8106 23.6132 15.808 23.5348 14.8053Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.3673 15.263C28.9355 14.9529 28.485 14.6582 28.0165 14.3809C27.4854 14.5008 26.9676 14.6431 26.4644 14.8053C26.3859 15.8078 26.3074 16.8105 26.229 17.8134C27.0477 17.8773 27.8624 18.0054 28.6657 18.1975C28.8996 17.2193 29.1335 16.2411 29.3673 15.263Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.6293 16.0083C22.7167 16.0796 21.8084 16.2223 20.9128 16.4365C20.866 16.2409 20.8192 16.0452 20.7725 15.8496C21.6987 15.6283 22.6382 15.4807 23.5821 15.4067C23.5979 15.6073 23.6137 15.8078 23.6293 16.0083Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.723 17.2113C22.8731 17.2778 22.0271 17.4107 21.1931 17.6102C21.1462 17.4145 21.0995 17.2188 21.0527 17.0233C21.9175 16.8165 22.7947 16.6787 23.676 16.6099C23.6917 16.8102 23.7073 17.0108 23.723 17.2113Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.864 17.4143C27.6536 17.3769 27.4425 17.3436 27.231 17.3145C26.8832 17.2664 26.6241 16.9711 26.6542 16.6392C26.6843 16.3074 27.0168 16.0666 27.3955 16.119C27.6225 16.1502 27.8491 16.1859 28.075 16.2261C28.4519 16.2927 28.6958 16.6247 28.6223 16.9493C28.549 17.2746 28.2105 17.4753 27.864 17.4143Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.2656 18.4079C30.4634 18.0756 29.641 17.8098 28.8071 17.6103C28.854 17.4146 28.9007 17.2189 28.9475 17.0234C29.8122 17.2301 30.6647 17.5059 31.4966 17.8504C31.4196 18.0362 31.3427 18.2221 31.2656 18.4079Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.051 16.5974C30.9657 16.8325 30.6782 16.9443 30.4065 16.8559C30.135 16.7674 29.9687 16.5092 30.0375 16.2688C30.1062 16.0284 30.3975 15.9011 30.6855 15.9948C30.9739 16.0882 31.1362 16.3623 31.051 16.5974Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9644 16.2691C20.0331 16.5097 19.8668 16.768 19.5954 16.8562C19.3238 16.9441 19.0363 16.8323 18.9509 16.5977C18.8656 16.3626 19.0281 16.0885 19.3164 15.9952C19.6044 15.9017 19.8959 16.0288 19.9644 16.2691Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.8634 15.8737C24.864 16.0736 24.6843 16.2364 24.4617 16.2432C24.2391 16.2503 24.0494 16.0986 24.0376 15.8995C24.026 15.7002 24.2055 15.5278 24.4391 15.5203C24.6727 15.5129 24.8624 15.6738 24.8634 15.8737Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.9644 15.8995C25.9526 16.0991 25.7628 16.2504 25.5404 16.2432C25.3179 16.2364 25.1382 16.0736 25.1387 15.8737C25.1396 15.674 25.3294 15.5127 25.5629 15.5203C25.7966 15.5273 25.976 15.7002 25.9644 15.8995Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.3923 16.8046C25.3867 17.0045 25.2116 17.1617 25.0009 17.1617C24.7904 17.1616 24.6153 17.0046 24.6095 16.8046C24.604 16.6053 24.7791 16.4379 25.0009 16.4385C25.2227 16.438 25.3978 16.6052 25.3923 16.8046Z",
					fill: "#FFE15A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53167",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHrFlag);
export { ForwardRef as ReactComponent };
